import { generatePath, useHistory } from 'react-router'
import {
  reportsMetabaseCampaignPath,
  reportsMetabaseCampaignPersonalisePath,
  unifiedFlowPaths,
} from 'app/navigation/paths'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { fetchCampaignData } from 'workflow/Workflow.actions'

import breakpoints from 'common/breakpoints'
import Button from 'common/components/button'
import {
  hideLeftPanel,
  selectLeftPanelVisibility,
  showLeftPanel,
} from 'common/components/leftPanel'
import SubNavBar from 'common/components/navigation/subNavBar'
import Tooltip from 'common/components/Tooltip'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { useWindowDimensions } from 'common/hooks/useWindowDimensions'
import { SidebarLeftMenu as SidebarLeftMenuIcon } from 'common/icons'
import {
  getIsPersonalized,
  getStepStatus,
} from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedComponentElement,
} from 'features/unifiedFlow/contentPage/hooks'

import HeaderNavigation from './HeaderNavigation'
import WorkflowField from './WorkflowField'

const Header = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const { content } = useContent()
  const { data: selectedElement } = useSelectedComponentElement()

  const { screenWidth } = useWindowDimensions()

  const leftPanelVisibility = useAppSelector(selectLeftPanelVisibility)

  const { showMetabaseLiveboard, enableMetabaseContextual } = useFlags()

  const resultsStepsStatus = getStepStatus(content?.steps_status, 'results')

  const handleViewReport = async () => {
    if (accountId) {
      const campaignId = selectedElement?.campaign_id

      if (campaignId) {
        await dispatch(fetchCampaignData(campaignId))
      }

      const reportsUrl = generatePath(reportsMetabaseCampaignPath, {
        accountId,
      })
      history.push(reportsUrl)
    }
  }

  const handleViewContextualReport = async () => {
    if (accountId) {
      const campaignId =
        selectedElement?.campaign_id ?? selectedElement?.personalization_id

      if (selectedElement?.campaign_id) {
        await dispatch(fetchCampaignData(selectedElement.campaign_id))
      }

      const reportsUrl = generatePath(reportsMetabaseCampaignPersonalisePath, {
        accountId,
      })
      history.push(
        campaignId ? `${reportsUrl}?campaign_name=${campaignId}` : reportsUrl
      )
    }
  }

  return (
    <SubNavBar
      title={<WorkflowField />}
      backLink={unifiedFlowPaths.home}
      preTitle={
        <Button
          size="small"
          variant="icon"
          className="mr-2 lg:hidden"
          prefixIcon={
            <Tooltip
              overlay={
                leftPanelVisibility === 'hidden' ||
                (leftPanelVisibility === 'auto' && screenWidth < breakpoints.md)
                  ? 'Show panel'
                  : 'Hide panel'
              }
            >
              <SidebarLeftMenuIcon
                isDefaultColor={false}
                className="text-white w-5 h-5"
              />
            </Tooltip>
          }
          onClick={() => {
            leftPanelVisibility === 'hidden'
              ? dispatch(showLeftPanel())
              : leftPanelVisibility === 'auto' && screenWidth < breakpoints.md
                ? dispatch(showLeftPanel())
                : dispatch(hideLeftPanel())
          }}
        />
      }
      rightNav={
        resultsStepsStatus !== 'hidden' && showMetabaseLiveboard ? (
          !getIsPersonalized(selectedElement) ? (
            <Button
              variant="primary"
              onClick={handleViewReport}
              disabled={resultsStepsStatus === 'disabled'}
              size="small"
            >
              VIEW REPORT
            </Button>
          ) : enableMetabaseContextual ? (
            <Button
              variant="primary"
              onClick={handleViewContextualReport}
              disabled={resultsStepsStatus === 'disabled'}
              size="small"
            >
              VIEW REPORT
            </Button>
          ) : undefined
        ) : undefined
      }
    >
      <HeaderNavigation />
    </SubNavBar>
  )
}

export default Header
